import { PhysicalInventoryStatus } from "./physical-inventory-enums"

export class InventoryPhysicalReport {
    public date: Date | null = null;
    public totalValue: number = 0;
    public status: PhysicalInventoryStatus = PhysicalInventoryStatus.inProgress;

    public serviceCenterGroups: InventoryReportServiceCenterGroup[] = [];
}

export class InventoryReportServiceCenterGroup {
    public serviceCenterId: string = '';
    public controlGroupsValue: number = 0;
    public shipmentsValue: number = 0;
    public ordersValue: number = 0;
    public adjustmentsValue: number = 0;
    public totalValue: number = 0;
}